import { joinPhone } from "pages/Administration/Organisation/organisationContactsRules";

export const contactUrl = (domain) => `${domain.replace(/\/?$/, "/")}common-organization-contacts/`;

// GET responses may serialize flags as booleans, numbers or strings.
// An omitted activity flag must not hide a returned contact.
const contactFlag = (value, fallback = false) => {
  if (value == null) return fallback;
  const normalized = typeof value === "string" ? value.trim().toLowerCase() : value;
  if ([true, 1, "true", "1"].includes(normalized)) return true;
  if ([false, 0, "false", "0"].includes(normalized)) return false;
  return fallback;
};

export const mapContact = (row) => ({
  id: row.id, name: row.name ?? "", designation: row.designation ?? "",
  role: row.role ?? "", email: row.email_address ?? "",
  contactType: row.is_primary != null ? (contactFlag(row.is_primary) ? "Primary" : "Secondary") : row.contact_type ?? "Secondary",
  phoneCode: row.phone_country_code ?? "+91", phoneNumber: row.mobile_number ?? "",
  phone: joinPhone(row.phone_country_code ?? "", row.mobile_number ?? ""),
  whatsappCode: row.whatsapp_country_code ?? "+91", whatsappNumber: row.whatsapp_number ?? "",
  whatsapp: joinPhone(row.whatsapp_country_code ?? "", row.whatsapp_number ?? ""),
  active: contactFlag(row.is_active, true),
});

export const readContacts = (response) => {
  const rows = Array.isArray(response) ? response : response?.data ?? response?.results ?? response;
  const list = Array.isArray(rows) ? rows : rows?.id != null ? [rows] : null;
  if (!list || list.some((row) => !row || row.id == null)) throw new Error("Invalid contact list response.");
  return list.filter((row) => !contactFlag(row.isdeleted) && !contactFlag(row.is_delete)).map(mapContact);
};

export const contactPayload = (draft, deleting = false) => ({
  ...(draft.id != null ? { id: draft.id, is_delete: deleting } : {}),
  name: draft.name.trim(), designation: draft.designation?.trim() || null,
  phone_country_code: draft.phoneCode, mobile_number: draft.phone.trim(),
  whatsapp_country_code: draft.whatsapp.trim() ? draft.whatsappCode : null,
  whatsapp_number: draft.whatsapp.trim() || null,
  email_address: draft.email.trim(), contact_type: draft.contactType,
  role: draft.role, is_active: draft.active,
});
